import { createTheme } from '@mantine/core';

const FONT =
  "'Montserrat', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

export const theme = createTheme({
  fontFamily: FONT,
  headings: { fontFamily: FONT, fontWeight: '600' },
  primaryColor: 'green',
  defaultRadius: 'md',
  components: {
    // Loading buttons show three dots in place of a spinner.
    Button: { defaultProps: { loaderProps: { type: 'dots' } } },
    ActionIcon: { defaultProps: { loaderProps: { type: 'dots' } } },
    Paper: { defaultProps: { radius: 'lg' } },
    Card: { defaultProps: { radius: 'lg' } },
    Modal: { defaultProps: { centered: true, radius: 'lg' } },
    Table: { defaultProps: { verticalSpacing: 'sm', highlightOnHover: true } },
  },
});
